import type { Translation } from '../types.ts';
import type en from '../en/newsletter.ts';

export default {
    nav: {
        campaigns: 'Campagnes',
        subscribers: 'Abonnees',
        settings: 'Instellingen',
    },
    campaignStatus: {
        scheduled: 'Ingepland',
        sending: 'Bezig met verzenden',
        sent: 'Verzonden',
        failed: 'Mislukt',
    },
    subscriberStatus: {
        confirmed: 'Bevestigd',
        pending: 'In afwachting',
        unsubscribed: 'Afgemeld',
    },
    shared: {
        anyStatus: 'Elke status',
        subject: 'Onderwerp',
        settingsSaved: 'Instellingen opgeslagen',
    },
    campaigns: {
        title: 'Nieuwsbriefcampagnes',
        new: 'Nieuwe campagne',
        empty: 'Nog geen campagnes. Maak er een aan om je abonnees te mailen.',
        progress: 'Voortgang',
        scheduledOrSent: 'Ingepland / verzonden',
        sentCount: '{n} verzonden',
    },
    campaign: {
        message: 'Bericht',
        body: 'Inhoud',
        plainText: 'Platte-tekstversie (optioneel)',
        plainTextHint: 'Laat leeg om die automatisch uit de HTML af te leiden. Een tekstversie verbetert de bezorgbaarheid.',
        audience: 'Ontvangers',
        audienceCount: '{number} bevestigde abonnee | {number} bevestigde abonnees',
        sentSoFar: 'Tot nu toe verzonden: {sent} / {total}',
        skipped: 'Overgeslagen',
        testTitle: 'Test versturen',
        testRecipient: 'Testontvanger',
        testPlaceholder: "jij{'@'}voorbeeld.nl",
        sendTest: 'Test versturen',
        sendTitle: 'Versturen',
        sendNow: 'Nu versturen',
        scheduleLater: 'Of inplannen voor later',
        schedule: 'Inplannen',
        scheduledFor: 'Ingepland voor {date}.',
        cancelSchedule: 'Planning annuleren',
        dangerZone: 'Gevarenzone',
        delete: 'Campagne verwijderen',
        created: 'Campagne aangemaakt',
        testEmailMissing: 'Vul een e-mailadres in om de test naartoe te sturen.',
        testSent: 'Test verstuurd naar {email}',
        confirmSend: '"{subject}" nu naar {n} bevestigde abonnee versturen? Dit kan niet ongedaan worden gemaakt. | "{subject}" nu naar {n} bevestigde abonnees versturen? Dit kan niet ongedaan worden gemaakt.',
        queued: 'Campagne staat klaar om te versturen',
        pickDate: 'Kies eerst een datum en tijd.',
        scheduled: 'Campagne ingepland',
        unscheduled: 'Teruggezet naar concept',
        confirmDelete: '"{subject}" verwijderen?',
        deleted: 'Campagne verwijderd',
    },
    subscribers: {
        title: 'Abonnees',
        exportCsv: 'CSV exporteren',
        exportFailed: 'Exporteren mislukt (HTTP {status})',
        searchPlaceholder: 'Zoeken op e-mailadres…',
        confirmedCount: '{n} bevestigde abonnee | {n} bevestigde abonnees',
        empty: 'Geen abonnees die aan deze filters voldoen.',
        source: 'Bron',
        confirmedAt: 'Bevestigd op',
        confirmRemove: '{email} definitief verwijderen? Dit kan niet ongedaan worden gemaakt.',
        removed: 'Abonnee verwijderd',
    },
    settings: {
        title: 'Nieuwsbriefinstellingen',
        subscription: 'Inschrijving',
        doubleOptIn: 'Bevestiging per e-mail vereisen (double opt-in)',
        doubleOptInHelp: 'Aanbevolen. Nieuwe abonnees moeten op een bevestigingslink klikken voordat ze campagnes ontvangen. Dit is de standaard die past bij de AVG en beschermt je reputatie als afzender. Zet dit alleen uit als je op een andere manier toestemming vastlegt.',
        confirmationSubject: 'Onderwerp bevestigingsmail',
        confirmationSubjectPlaceholder: 'Bevestig je inschrijving op de nieuwsbrief',
        confirmationSubjectHint: 'Laat leeg om de standaard te gebruiken.',
        sender: 'Afzender',
        senderHelp: 'Het Van:-adres waarmee nieuwsbrieven worden verstuurd. Laat leeg om de standaard van de website te gebruiken. Versturen mislukt als geen van beide is ingesteld.',
        senderHelpWithDefault: 'Het Van:-adres waarmee nieuwsbrieven worden verstuurd. Laat leeg om de standaard van de website te gebruiken ({address}). Versturen mislukt als geen van beide is ingesteld.',
        fromEmail: 'E-mailadres afzender',
        fromEmailPlaceholder: "nieuws{'@'}voorbeeld.nl",
        fromName: 'Naam afzender',
        fromNamePlaceholder: 'Voorbeeld Nieuwsbrief',
        effectiveSender: 'Werkelijke afzender: {address}',
        noSender: 'Geen afzender ingesteld: campagnes kunnen pas worden verstuurd als je er hier of bij de website een instelt.',
    },
} satisfies Translation<typeof en>;
